import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TableNumberService {

  private _inCheckoutFlow = false;

  private tableNumber: string = ''; // default for testing purposes
  private voucher = false; // default for testing purposes
  constructor() { }

  setInCheckoutFlow(value: boolean) {
    this._inCheckoutFlow = value;
  }

  isInCheckoutFlow(): boolean {
    return this._inCheckoutFlow;
  }

  resetFlow() {
    this._inCheckoutFlow = false;
  }

  setTableNumber(tableNumber: string): void {
    this.tableNumber = tableNumber;
  }

  getTableNumber(): string {
    return <string>this.tableNumber;
  }

  setVoucher(voucher: boolean): void {
    this.voucher = voucher;
  }

  getVoucher(): boolean {
    return <boolean>this.voucher;
  }
}
